import { Component, OnInit, Output, ViewChild , EventEmitter , ElementRef , ChangeDetectorRef,AfterViewInit, Inject } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';
import { MatStepper } from '@angular/material/stepper';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import { GooglePlacesAPI , Maps} from '../services/googlePlaces.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-vet',
  templateUrl: './add-vet.component.html',
  styleUrls: ['./add-vet.component.css']
})
export class AddVetComponent implements AfterViewInit {

  @Output() submitted = new EventEmitter()
  @ViewChild('searchGoogleAddressInput', { static: false }) public searchElementRef: ElementRef;

  data:any = {
    vet: {
      name: '',
      phone: '',
      displayAddress: ''
    }
  };
  errorMessage:string;
  tenantCountry: string = 'US'; // Default to US

  constructor(
    private googlPlacesApi: GooglePlacesAPI,    
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { 
    googlPlacesApi.api.then((maps) => {
      setTimeout(() => {
        this.initAutocompleteAddress(maps);
      }, 1000);
    });
  }

  ngAfterViewInit(): void {
    this.googlPlacesApi.api.then((maps) => {
      setTimeout(() => {
        this.initAutocompleteAddress(maps);
      }, 1000);
    });
  }

  ngOnInit(): void {
    // Extract tenant country from dialog data if available
    if (this.dialogData && this.dialogData.tenantCountry) {
      this.tenantCountry = this.dialogData.tenantCountry;
    }
  }

  addVet() {
    this.errorMessage = '';
    if (!this.data.name || this.data.name == '' || !this.data.phone || this.data.phone == '' || this.data.phone.length < 10) {
      this.errorMessage = 'Please fill in all fields';
      return;
    }
    
    // Validate address if provided
    if (this.data.address && this.data.address.zip) {
      const postalCode = this.data.address.zip;
      let isValidPostalCode = false;
      
      if (this.tenantCountry === 'CA') {
        isValidPostalCode = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(postalCode);
      } else {
        isValidPostalCode = /^\d{5}$/.test(postalCode);
      }
      
      if (!isValidPostalCode) {
        this.errorMessage = this.tenantCountry === 'CA' 
          ? 'Please enter a valid Canadian postal code (format: A1A 1A1)' 
          : 'Please enter a valid US zip code (5 digits)';
        return;
      }
    }
    
    this.submitted.emit(this.data);
  }

  googlePlacesSearch(){
    this.googlPlacesApi.api.then((maps) => {
      setTimeout(() => {
        this.initAutocompleteAddress(maps);
      }, 1000);
    });
  }

  initAutocompleteAddress(maps:Maps) {
    var autocomplete = new maps.places.Autocomplete(
      this.searchElementRef.nativeElement,{componentRestrictions: { country: [this.tenantCountry] },fields: ["address_components", "geometry", "formatted_address"],
      types: ["address"],}
    );
    delete this.data.address;
    autocomplete.addListener('place_changed', () => {
      let place = autocomplete.getPlace();
      let address1 = "";
      let postcode = "";
      let locality = "";
      let country = "";
      let state = "";
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case "route": {
            address1 += component.short_name;
            break;
          }
          case "postal_code": {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case "locality":
            locality = component.long_name;
            break;
          case "administrative_area_level_1": {
            state = component.long_name;
            break;
          }
          case "country":
            country = component.long_name;
            break;
        }
      }
      this.data.address= {
        line1: address1,
        city: locality,
        state: state,
        zip: postcode,
        country: country,
        displayAddress: place.formatted_address
      }
      this.data.displayAddress = place.formatted_address;
      
      // Validate postal code based on tenant country
      this.validateAddressData();
      
      this.cdr.detectChanges();
    }); 
  }

  validateAddressData() {
    if (this.data.address && this.data.address.zip) {
      const postalCode = this.data.address.zip;
      let isValidPostalCode = false;
      
      if (this.tenantCountry === 'CA') {
        // Canadian postal code format: A1A 1A1 (with or without space)
        isValidPostalCode = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(postalCode);
      } else {
        // US zip code format: 5 digits
        isValidPostalCode = /^\d{5}$/.test(postalCode);
      }
      
      if (!isValidPostalCode) {
        console.warn(`Invalid postal code format for ${this.tenantCountry}: ${postalCode}`);
        // You could set an error message here if needed
      }
    }
  }

}
